module.exports = __webpack_public_path__ + "img/blocks-image-17-img6.34ab2147.jpg";